import { api } from '@/lib/api';

export function uploadCompanyLogo(companyId: string, file: File): Promise<{ logoUrl: string }> {
  const form = new FormData();
  form.append('file', file);
  return api.upload<{ logoUrl: string }>(`/v4/crm/companies/${companyId}/logo`, form);
}

export const removeCompanyLogo = (companyId: string) => api.delete<{ logoUrl: null }>(`/v4/crm/companies/${companyId}/logo`);
